<template>
        <div style="height:100%;width:100%;" class="diagonal-split-background">

          <v-container class="mb-0 pb-0">




      <v-row>
        <v-col cols="12" xs="5">

          <v-row
            align="end"
            justify="center"


          >
          <v-col cols="9" md="5">
            <v-card

              class="ml-3 mr-3 mt-3 mb-0 pa-4"
              outlined
              raised
            >
            <v-row>
              <v-col cols="12">
                <v-row justify="center" align="end">
                <img src="/images/logos/shuttle-icon.png" />
              </v-row>
              </v-col>
              <v-col cols="12">
                <v-row justify="center">

                  <h2 class="headline" style="font-size:16px;">{{ authStatusTitle }}</h2>


            </v-row>
            </v-col>
            <v-card-subtitle transition="scale-transition" v-if="$route.name == 'forgotpassword'">Enter your username to continue</v-card-subtitle>
            <v-col xs="12" cols="12">

              <router-view></router-view>

            <!--  <SignUp v-if="$route.name == 'SignUp'" :setAuthStatus="setAuthStatus"></SignUp>
              <ConfirmSignUp v-else-if="$route.name == 'ConfirmSignUp'" :setAuthStatus="setAuthStatus"></ConfirmSignUp>
              <ForgottenPassword v-else-if="$route.name == 'ForgottenPassword' || authStatus == 'forgotpassword-verification'" :setAuthStatus="setAuthStatus"></ForgottenPassword>
              <Login v-else :setAuthStatus="setAuthStatus"></Login>
            -->
            </v-col>


            </v-row>





            <v-divider></v-divider>
            <div class="text-center mt-3" v-if="$route.name == 'Login'">
              <span style="font-size:14px;">New to Shuttle? </span><a style="font-size:14px;color:#0366d6;text-decoration:none;" @click="$router.push({name:'SignUp'})">Create an account</a>
            </div>
            <div class="text-left mt-3" v-else-if="$route.name == 'SignUp'">

              <v-icon>mdi-login</v-icon><a style="font-size:14px;color:#0366d6;text-decoration:none;" @click="$router.push({name:'Login'})">Sign in instead</a>
            </div>
            <div class="text-center mt-3" v-if="$route.name == 'ConfirmSignUp'">
              <span style="font-size:14px;">Didn't receive your code? </span><a style="font-size:14px;color:#0366d6;text-decoration:none;" @click="resendCode()">Send another</a>
            </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          align="end"
          justify="center"


        >
          <v-col cols="9" md="5">
            <v-card
            class="ml-3 mr-3 pl-3 pr-3 mt-0 pt-2 pb-2"


                    outlined

          raised
          >



        <div :class="`d-flex justify-space-around`">

       <a
            style="font-size:12px;font-weight:600;"
              text
              color="#0366d6"
              class="underline-hover-link text-capitalize"
              link
            >
              Help
            </a>


            <a
            style="font-size:12px;font-weight:600;"
              text
              color="#0366d6"
              class="underline-hover-link text-capitalize"
              link
            >
              Contact Shuttle
            </a>

        <a
        style="font-size:12px;font-weight:600;"
          text
          class="underline-hover-link text-capitalize"
          color="#0366d6"
          link
        >
          About
        </a></div>




    </v-card></v-col></v-row>


          <v-row>
            <v-col cols="12" xs="5">
              <v-row justify="center" align="end">


           </v-row>
         </v-col>

           </v-row>







        </v-col>

      </v-row>
      </v-container>




  </div>


</template>


<script>

//import {getHash,hasHash,isLoginHash} from '@/authentication/auth.js'

export default {
  name: 'Welcome',

  components: {
    /* Login: () => import('@/components/login/Login.vue'),
     SignUp: () => import('@/components/login/SignUp.vue'),
     ConfirmSignUp: () => import('@/components/login/ConfirmSignUp.vue'),
     ForgottenPassword: () => import('@/components/login/ForgottenPassword.vue') */
  },

  data: function() {
    return {
      authStatus: 'login',
    }
 },

 methods: {
   setAuthStatus(new_status) {
     this.authStatus = new_status;
   },
   resendCode() {

   },
 },

 computed: {
   authStatusTitle() {
     if (this.$route.name == 'SignUp') { return 'Sign up with a new account'; }
     else if (this.$route.name == 'ConfirmSignUp') { return 'Verify your email'; }
     else if (this.$route.name == 'ForgottenPassword') { return "Let's try resetting your password"; }
     else if (this.$route.name == 'forgotpassword-verification') { return "A verification code has been sent to your email. Enter it below so that we can reset your account's password."; }
     return 'Sign in to Shuttle';
   },
 },

  created() {
      //this.$router.push({name: "Login"});
    if (this.$store.state.hashtokens) {
      if (this.$store.state.hashtokens['id_token']) {
        this.$router.push({name: "ProcessLogin"});
      } else {
        this.$router.push({name: "Login"});
      }
    } else {
      this.$router.push({name: "Login"});
    }
  },

}
</script>



<style scoped>

.diagonal-split-background{
  background-color: #0882B8;
  background-image: -webkit-linear-gradient(30deg, #0882B8 50%, #00BD64 50%);
}

a.underline-hover-link.text-capitalize:hover {
  text-decoration: underline;
}

</style>
